import React from "react";

const BotaoAdicionar = ({ ativo, onClick }) => (
    <button className="botao-principal botao-principal-redondo" title="Adicionar" onClick={onClick} disabled={!ativo}>
        +
    </button>
);

export default BotaoAdicionar;
